import styled from "styled-components";
import { TableEl } from "./Table";

export const TableRow = styled.tr`
  ${TableEl} &:not(:last-of-type) {
    border-bottom: 1px solid var(--color-border);
  }
`;
